import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
// import Button from "@mui/material/Button";
import DateRange from "../../../common/dateTime/DateRange";
import closeIcon from "../../../assets/close.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CustomerCareAddFilters = (props) => {
  const { open, handleFilterModalClose, filterSearchedData } = props;
  const [appliedFilters, setAppliedFilters] = useState({
    email: "",
    phone: null,
    doctorname: "",
    doctorid: "",
    clinicid: "",
  });
  const [filterRange, setFilterRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [openRange, setOpenRange] = useState(false);

  const daterange = {
    inputlabel: "Filter by date",
    btnlable: "Apply",
    btnlableClear: "Clear",
    customStyle: {
      txtStyle: {
        textAlign: "center",
      },
      frmStyle: {
        position: "absolute",
        zIndex: 1,
        top: "15%",
        left: "30%",
      },
    },
    pckrStyle: true,
    handleFilter: (val) => {
      setFilterDateRange(val);
    },
    openRange: openRange,
    setOpenRange: setOpenRange,
    setFilterRange: setFilterRange,
  };

  const setFilterDateRange = (val) => {
    setFilterRange(() => val);
    setOpenRange(() => false);
  };

  const setFilters = (name, e) => {
    const { value } = e?.target;
    const filter = { ...appliedFilters };
    filter[name] = value;
    setAppliedFilters(() => filter);
  };

  const clearFilters = () => {
    const filter = {
        email: "",
        phone: null,
        doctorname: "",
        doctorid: "",
        clinicid: "",
    };
    setAppliedFilters(() => filter);
  };

  const applyFilters = () => {
    filterSearchedData(appliedFilters, filterRange);
  };

  return (
    <Modal
      open={open}
      onClose={handleFilterModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div
          style={{
            background: "rgb(240, 241, 245)",
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            height: "10%",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <p>
            <b>Filters & Search</b>
          </p>
          <img
            style={{
              height: "20px",
              position: "absolute",
              right: "30px",
              cursor: "pointer",
            }}
            src={closeIcon}
            onClick={() => handleFilterModalClose()}
          />
        </div>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: "20px" }}
        >
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Search By Email"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("email", e)}
              size="small"
              value={appliedFilters.email}
            />
            <TextField
              id="outlined-basic"
              label="Search By Phone Number"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("phone", e)}
              size="small"
              value={appliedFilters.phone}
            />
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Doctor Name"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("docName", e)}
              value={appliedFilters.ticketId}
              size="small"
            />
            <TextField
              id="outlined-basic"
              label="Doctor ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("docID", e)}
              value={appliedFilters.status}
              size="small"
            />
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Clinic ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("clinicId", e)}
              value={appliedFilters.name}
              size="small"
            />
            {/* <TextField
              id="outlined-basic"
              label="Search By Clinic ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("clinicId", e)}
              value={appliedFilters.clinicId}
              size="small"
            /> */}
          </Grid>
          
          <Grid
            style={{
              width: "100%",
              display: "inline-flex",
              justifyContent: "end",
              marginTop: "25px",
              marginRight: "10px",
            }}
          >
            <Button
              variant="outlined"
              //   size="small"
              onClick={() => clearFilters()}
              style={{ minWidth: "10rem", borderRadius: "15px" }}
              sx={1}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              //   size="small"
              onClick={() => applyFilters()}
              style={{
                marginLeft: "30px",
                minWidth: "10rem",
                borderRadius: "15px",
                color: "white",
              }}
            >
              Apply
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CustomerCareAddFilters;
